import { useQuery } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Version } from 'types';

const getVersions = async (
  orgId: string,
  projectId?: string,
  archived?: boolean
): Promise<Version[]> => {
  const params = new URLSearchParams({ orgId });
  if (projectId) {
    params.append('projectId', projectId);
  }
  if (archived !== undefined) {
    params.append('archived', archived.toString());
  }
  const response = await customAxios.get<Version[]>(`/versions?${params.toString()}`);
  return response.data;
};

/** @param enabledOverride `false` skips the query (no project). */
export const useGetVersions = (
  orgId: string,
  projectId?: string,
  archived?: boolean,
  enabledOverride?: boolean
) =>
  useQuery<Version[]>({
    queryKey: ['versions', orgId, projectId, archived],
    queryFn: () => getVersions(orgId, projectId, archived),
    enabled: !!orgId && (enabledOverride !== false),
  });
